import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { ArtifactEditorForm } from "@/features/lead-gen/components/ArtifactEditorForm";
import { LeadGenDetailShell } from "@/features/lead-gen/components/LeadGenDetailShell";
import { useLeadGen } from "@/features/lead-gen/LeadGenContext";
import { useNav } from "@/utils/nav";

export const Route = createFileRoute("/_app/sales/leads/artifacts/$artifactId")({
    component: LeadArtifactDetailPage,
});

function LeadArtifactDetailPage() {
    const { artifactId } = Route.useParams();
    const { artifacts, setArtifacts } = useLeadGen();
    const navigate = useNavigate();
    const artifact = artifacts.find((item) => item.id === artifactId) ?? null;

    useNav([
        { label: "Sales", route: { to: "/sales/leads" } },
        { label: "Leads", route: { to: "/sales/leads" } },
        { label: "Artefacts", route: { to: "/sales/leads/artifacts" } },
        {
            label: artifact?.name ?? "Artefact",
            route: { to: "/sales/leads/artifacts/$artifactId", params: { artifactId } },
        },
    ]);

    if (!artifact) {
        return (
            <LeadGenDetailShell
                backTo="/sales/leads/artifacts"
                backLabel="All artefacts"
                summary={<p className="text-slate-500 text-sm">This artefact may have been deleted.</p>}
            >
                <p className="bg-white/70 p-6 border border-slate-200 rounded-lg text-slate-500 text-sm text-center">
                    Artefact not found.
                </p>
            </LeadGenDetailShell>
        );
    }

    return (
        <LeadGenDetailShell
            backTo="/sales/leads/artifacts"
            backLabel="All artefacts"
            summary={
                <div className="flex items-center gap-2 min-w-0">
                    <span className="font-medium text-slate-800 text-lg truncate">{artifact.name}</span>
                    <span className="text-slate-500 text-sm">
                        Edits apply the next time a template that uses this artefact generates a draft.
                    </span>
                </div>
            }
        >
            <ArtifactEditorForm
                artifact={artifact}
                onCancel={() => void navigate({ to: "/sales/leads/artifacts" })}
                onSave={(next) => {
                    setArtifacts((current) => current.map((item) => (item.id === next.id ? next : item)));
                }}
            />
        </LeadGenDetailShell>
    );
}
